/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["entry-drag-preview{position:fixed;top:0;left:0;z-index:10;background-color:#e8f0fe;color:#1976d2;width:185px;box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);pointer-events:none}entry-drag-preview .selected-entry-count{width:22px;height:22px;line-height:22px;text-align:center;font-weight:500;background-color:#689f38;color:#fff;position:absolute;top:-7px;right:-7px;border-radius:50%;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}"];
export { styles as styles };
